import axios from 'axios'
import qs from 'qs'

const fetch = axios.create({
  timeout: 30000,
})

fetch.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

fetch.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.errorCode !== 0) {
      if (res.errorCode === 205) {
        localStorage.removeItem('userToken')
        window.location.href = '/'
      }
      return Promise.reject(res.errorMsg)
    } else {
      return response
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default fetch
